import { Button, Typography } from "@mui/material";
import { SentimentDissatisfied } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const Unauthorized = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-lg text-center">
        {/* Icon */}
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-red-100">
          <SentimentDissatisfied className="h-7 w-7 text-red-600" />
        </div>

        {/* Status Code */}

        {/* Title */}
        <Typography variant="h5" className="mt-2 text-lg font-bold text-gray-800">
          Unauthorized Access
        </Typography>

        {/* Message */}
        <Typography className="mt-3 text-sm text-gray-600 leading-relaxed">
          You don’t have permission to access this page. If you believe this is
          a mistake, please contact your administrator.
        </Typography>

        {/* Actions */}
        <div className="mt-6 flex justify-center gap-3">

          <Button
            variant="contained"
            sx={{
              textTransform: "none",
              fontWeight: "bold",
            }}
            onClick={() => navigate("/")}
          >
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
